import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const schema = z.object({
  task: z.string().optional(),
  tasks: z
    .union([
      z.literal('completed'),
      z.literal('overdue'),
      z.literal('upcoming'),
    ])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_private/_route/_internal/home/')({
  beforeLoad: ({ search }) => {
    if (!search.tasks) {
      throw redirect({
        replace: true,
        search: {
          tasks: 'upcoming',
        },
        to: '.',
      });
    }
  },
  validateSearch: schema,
});
